<div class="card" [class.card--small]="format() === 'small'" [class.card--large]="format() === 'large'">
    <div class="card__left-column">
        <img [src]="asset()" class="card__asset" alt="card" />
    </div>
    <div class="card__right-column">
        <div class="card__title">
            <web-device-type-label class="headline-bold" [type]="type()" [surname]="name()" />
            @if (serialNumber()) {
                <p class="card__serial-number">
                    {{ serialNumber() }}
                </p>
            }
        </div>
        <img [src]="asset()" class="card__asset" alt="card" />
        <ng-content></ng-content>
    </div>
</div>
